import "./App.css";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import AdminRouter from "./routes/AdminRouter";
import store from "./store/store";
import Alert, { CustomAlertProps } from "./components/Alert/Alert";
import Loader from "./components/loader/Loader";
import "@fortawesome/fontawesome-free/css/all.min.css";
// import ToastNotification from './components/Alert/ToastNotification';
import NotificationProvider from "./components/Alert/NotificationContext";
import "bootstrap/dist/css/bootstrap.min.css";

const alertProps: CustomAlertProps = {
  show: false,
  variant: "success",
  message: "This is a success message!",
  title: "Success",
  closeLabel: "Close",
};

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <NotificationProvider>
          <Alert {...alertProps} />
          <Loader />
          <BrowserRouter basename="/">
            <AdminRouter />
          </BrowserRouter>
        </NotificationProvider>
      </Provider>
    </div>
  );
}

export default App;
